import { faDownload } from "@fortawesome/pro-regular-svg-icons";
import { faCheckCircle, faExclamationCircle, faExclamationTriangle, faSpinnerThird } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UploadFileView } from "@yodlee/common-components";
import { NotificationUtils } from "@yodlee/common-components/dist/utilities";
import { Button, Col, Icon, Row, Tooltip, Typography } from "antd";
import { saveAs } from "file-saver";
import React, { useState } from "react";
import { DataUtils } from "../../utilities";
var CreateUsers = function (_a) {
    var _b;
    var visible = _a.visible, onCancel = _a.onCancel, authentication = _a.authentication, onCreate = _a.onCreate;
    var _c = useState(false), downloading = _c[0], setDownloading = _c[1];
    var _d = useState(false), uploading = _d[0], setUploading = _d[1];
    var _e = useState(), postUploadView = _e[0], setPostUploadView = _e[1];
    var _f = useState(), uploadedFiles = _f[0], setUploadedFiles = _f[1];
    var downloadTemplate = function () {
        setDownloading(true);
        DataUtils.user(authentication).getTemplate().then(function (template) {
            saveAs(new Blob([template.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), "Template: Bulk user registration.xlsx");
        }).finally(function () { return setDownloading(false); });
    };
    return (React.createElement(UploadFileView, { visible: visible, maxCount: 1, maxSize: 15, mode: "bulk", loading: uploading, supportedExtensions: ["xlsx"], name: "bulk-user", uploadText: postUploadView ? "Close" : "Upload and register", onCancel: onCancel, supportedFileTypes: ["*"], onChange: function (fileList) { setUploadedFiles(fileList); if (!((fileList === null || fileList === void 0 ? void 0 : fileList.length) > 0))
            setPostUploadView(undefined); }, header: ((_b = (uploadedFiles || [])) === null || _b === void 0 ? void 0 : _b.length) > 0 ? undefined : React.createElement(Button, { disabled: downloading, onClick: downloadTemplate },
            React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { spin: downloading, icon: downloading ? faSpinnerThird : faDownload }); } }),
            React.createElement("span", { className: "margin-left-sm" }),
            "Download template for bulk user registration"), postUploadView: postUploadView, onSubmit: function (files) {
            if (postUploadView) {
                onCancel();
                return;
            }
            setUploading(true);
            var userFormData = new FormData();
            userFormData.append("template", files[0].originFileObj);
            DataUtils.user(authentication).createMany(userFormData).then(function (data) {
                if (data.requestCount === 0) {
                    NotificationUtils.warning("Invalid request.", "No row present in file.", "ghost");
                }
                var successUsers = data.items.filter(function (item) { return item.responseCode === "R000"; });
                var failedUsers = data.items.filter(function (item) { return item.responseCode !== "R000"; });
                if (data.errors) {
                    var preview = React.createElement(BulkUserRegistrationFeedback, { allUsers: data.items, failedUsers: failedUsers });
                    setPostUploadView(preview);
                }
                if (successUsers.length > 0) {
                    onCreate(data);
                }
            }).finally(function () { return setUploading(false); });
        } }));
};
export default CreateUsers;
var BulkUserRegistrationFeedback = function (_a) {
    var failedUsers = _a.failedUsers, allUsers = _a.allUsers;
    var _b = useState(false), viewAll = _b[0], setViewAll = _b[1];
    var INITIAL_LIMIT = 4;
    var failureCount = failedUsers === null || failedUsers === void 0 ? void 0 : failedUsers.length;
    var totalCount = allUsers === null || allUsers === void 0 ? void 0 : allUsers.length;
    var countLimit = viewAll ? totalCount : INITIAL_LIMIT;
    return React.createElement(React.Fragment, null,
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("div", { style: { display: "flex", alignItems: "center" } },
            React.createElement("div", null,
                React.createElement(Icon, { className: "font-size-xxl color-pink", component: function () { return React.createElement(FontAwesomeIcon, { icon: faExclamationTriangle }); }, type: "warning", theme: "filled" })),
            React.createElement("span", { className: "padding-right-sm" }),
            React.createElement("div", { style: { fontWeight: "bold" } }, "".concat(failureCount, " users could not be registered"))),
        React.createElement("br", null),
        allUsers.map(function (item, index) {
            return index >= countLimit ? undefined :
                React.createElement(Row, { key: index, gutter: 16, style: { width: "100%" }, className: "padding-sm-vertical" },
                    React.createElement(Col, { span: 7 },
                        React.createElement(Typography.Paragraph, { ellipsis: true, className: "no-margin" }, item.uniqueKey || "N/A")),
                    React.createElement(Col, { span: 17 },
                        React.createElement(Typography.Paragraph, { ellipsis: true, className: "no-margin" },
                            React.createElement(FontAwesomeIcon, { className: (item === null || item === void 0 ? void 0 : item.responseCode) === "R000" ? "color-green" : "color-pink", icon: (item === null || item === void 0 ? void 0 : item.responseCode) === "R000" ? faCheckCircle : faExclamationCircle }),
                            React.createElement("span", { style: { paddingLeft: "4px" } }),
                            React.createElement(Tooltip, { style: { fontSize: "10px" }, title: item.message }, (item === null || item === void 0 ? void 0 : item.responseCode) === "R000" ? "Success" : item.message))));
        }),
        (totalCount > INITIAL_LIMIT) && React.createElement(Button, { onClick: function () { return setViewAll(!viewAll); }, type: "link", className: "no-padding" }, viewAll ? "Show less" : "+ ".concat(totalCount - INITIAL_LIMIT, " more")));
};
//# sourceMappingURL=index.js.map